import React from 'react';
import { TextField, EmailField, DateField, SimpleShowLayout } from 'react-admin';


const UserShow = (props)=> {
    return (
        <SimpleShowLayout {...props}>
            <TextField source='firstName' label="Nombre" />
            <TextField source='lastName' label="Apellido" />
            <EmailField source='email' label ="Correo Electronicol" />
            <TextField source="phone" label="Teléfono" />
            <DateField source="createdAt" label="Fecha de Registro" />
        </SimpleShowLayout>
    )

};

export default UserShow;